/**
 * Replaces underscores dashes with spaces and capitalizes each letter.
 *
 * @param {string} value Value to prettify
 * @return {string} Prettified input value.
 */
export const prettifyString = value => {
	let input = value;
	// If this has more than 1 thing, just take the first one
	if ( typeof input !== 'string' ) {
		if ( input.length > 1 ) {
			input = input[ 0 ];
		} else {
			return input;
		}
	}

	// Replace snake_case and dash-case with spaces
	let result = input.replace( /[_-]/g, ' ' );

	// Split the string into words
	let words = result.split( ' ' );

	// Capitalize the first letter of each word and handle camelCase
	words = words.map( word => {
		const capitalizedWord = word.charAt( 0 ).toUpperCase() + word.slice( 1 );

		// Check for camelCase within the word
		return capitalizedWord.replace( /([A-Z])/g, ' $1' ).trim();
	} );

	// Join the words back together with spaces
	result = words.join( ' ' );

	return result;
};

/**
 * Prettifies and localizes object types.
 *
 * @param {Array} objectTypes
 * @return {Array} Prettified object types
 */
export const prettifyAndLocalizeObjectType = objectTypes => {
	return objectTypes.map( objectType => {
		objectType.namePretty = prettifyString( localizeObjectType( objectType.name, objectType.count === 1 ) );
		return objectType;
	} );
};

/**
 * Localizes an object type string.
 *
 * @param {string}  objectType Object type string to localize.
 * @param {boolean} isSingular Boolean toogle (if false, will pull  the plural translation)
 * @return {string} Localized object type string.
 */
export const localizeObjectType = ( objectType, isSingular = true ) => {
	const postTypeKeysSingular = Object.keys( window?.QalaElasticCore?.localizedPostTypes || {} );
	const postTypeKeysPlural = Object.keys( window?.QalaElasticCore?.localizedPostTypesPlural || {} );

	let localizedName = objectType;
	if ( isSingular && postTypeKeysSingular.includes( objectType ) ) {
		localizedName = window.QalaElasticCore.localizedPostTypes[ objectType ];
	} else if ( ! isSingular && postTypeKeysPlural.includes( objectType ) ) {
		localizedName = window.QalaElasticCore.localizedPostTypesPlural[ objectType ];
	} else if ( postTypeKeysSingular.includes( objectType ) ) { // revert to singular if plural somehow doesn't exist
		localizedName = window.QalaElasticCore.localizedPostTypes[ objectType ];
	}

	return localizedName;
};
